import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'

////////////////////////////////////////////////////
// Vuetify
////////////////////////////////////////////////////
// import-excel 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

/**
 * Vuetify 설치
 */
import vuetify from "@/assets/plugins/vuetify";


import { toCamel, toSnake } from 'snake-camel';
Vue.use(toCamel);
Vue.use(toSnake);
Vue.use(VueTheMask);

/**
 * vue-infinite-loading 설치
 */
import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading);

import VueDataTable from "@/assets/plugins/vue-data-table";
Vue.use(VueDataTable);

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import-excel styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor, /* { default global options } */);

// register quill modules, you need to introduce and register before the vue program is instantiated
import Quill from 'quill';
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from "quill-image-resize-module--fix-imports-error";
Quill.register('modules/imageDrop', ImageDrop);
Quill.register("modules/imageResize", ImageResize);
// import-excel yourQuillModule from '../yourModulePath/yourQuillModule.js'
// Quill.register('modules/yourQuillModule', yourQuillModule)

/**
 * Draggable
 */
import draggable from 'vuedraggable';
Vue.component("draggable", draggable);

/**
 * Plugin 설치
 */
import Plugins from "@/assets/plugins";
Vue.use(Plugins);

/**
 * Global Mixins
 */
import {DEBUG} from "@/constants/env";

import Toasted from 'vue-toasted';
Vue.use(Toasted, { position: "top-center", duration: 2000 })

////////////////////////////////////////////////////
// Vue settings.
////////////////////////////////////////////////////
Vue.config.productionTip = DEBUG;
Vue.config.devtools = DEBUG;

const vm = new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
});

vm.$mount('#app');
store.vm = vm; // store 안에서 vue 사용할 수 있도록 함.
router.vm = vm; // router 안에서 vue 사용할 수 있도록 함.

export {vm}
